import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getBlackoutList(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-blackout?page=" + actions.page
        : apiUrl + "/opa-blackout" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_BLACKOUT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_BLACKOUT_RESPONSE_GET", value: error });
  }
}

function* getProductBlackoutList(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-product-blackout-date/${actions.productUuid}`;
    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_PRODUCT_BLACKOUT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_PRODUCT_BLACKOUT_RESPONSE_GET", value: error });
  }
}

function* getBlackout(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      apiUrl +
      `/opa-blackout/${actions.query.blackout_date_uuid}?include=dateRanges,products`;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "BLACKOUT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "BLACKOUT_RESPONSE_GET", value: error });
  }
}

function* resetBlackout() {
  yield put({ type: "BLACKOUT_RESPONSE_RESET" });
}

function* addBlackout(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.data),
    };

    let url = apiUrl + "/opa-blackout";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.createdAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BLACKOUT_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BLACKOUT_RESPONSE_ADD",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* deleteBlackout(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = apiUrl + "/opa-blackout/" + actions.data.blackout_date_uuid;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BLACKOUT_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BLACKOUT_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* updateBlackout(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = `${apiUrl}/opa-blackout/${actions.blackoutUuid}`;

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.updatedAt || response.uuid) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BLACKOUT_RESPONSE_UPDATE",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BLACKOUT_RESPONSE_UPDATE",
      value: {
        ...error,
        responseStatus: "error",
      },
    });
  }
}

function* addBlackoutProduct(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    if (!actions.form || !actions.form.form.blackoutUuid) {
      yield put({
        type: "BLACKOUT_PRODUCT_RESPONSE_ADD",
        value: {
          error: "Missing blackout UUID",
          responseStatus: "error",
        },
      });
      return;
    }

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form.form.blackoutFormData),
    };

    let url =
      apiUrl + "/opa-blackout/" + actions.form.form.blackoutUuid + "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (Array.isArray(response) || response.success) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BLACKOUT_PRODUCT_RESPONSE_ADD",
      value: {
        ...response,
        responseStatus,
      },
    });
  } catch (error) {
    yield put({
      type: "BLACKOUT_PRODUCT_RESPONSE_ADD",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

function* deleteBlackoutProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.payload.blackoutFormData),
    };

    let url =
      apiUrl + "/opa-blackout/" + actions.payload.blackoutUuid + "/products";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    let responseStatus = "warning";
    if (response) {
      if (response.status == 200 || response.status == 204) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({
      type: "BLACKOUT_PRODUCTS_RESPONSE_DELETE",
      value: { ...response, responseStatus },
    });

    return response;
  } catch (error) {
    yield put({
      type: "BLACKOUT_PRODUCTS_RESPONSE_DELETE",
      value: { ...error, responseStatus: "error" },
    });
    throw error;
  }
}

function* getBlackoutProducts(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url = `${apiUrl}/opa-blackout/${actions.blackoutUuid}`;
    if (enviromentUrl !== "") {
      url += `?env=${enviromentUrl}`;
    }

    const blackoutResponse = yield call(apiCall, "get", url, requestOptions);

    if (
      blackoutResponse &&
      blackoutResponse.products &&
      Array.isArray(blackoutResponse.products) &&
      blackoutResponse.products.length > 0
    ) {
      yield put({
        type: "BLACKOUT_PRODUCTS_RESPONSE_GET",
        value: blackoutResponse.products,
      });
    } else {
      yield put({ type: "BLACKOUT_PRODUCTS_RESPONSE_GET", value: [] });
    }
  } catch (error) {
    yield put({ type: "BLACKOUT_PRODUCTS_RESPONSE_GET", value: [] });
  }
}

function* getProductBlackout(actions) {
  const uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url;
    if (actions.blackoutUuid) {
      url = `${apiUrl}/opa-product-blackout-date/${actions.productUuid}/${actions.blackoutUuid}`;
    } else {
      url = `${apiUrl}/opa-product-blackout-date/${actions.productUuid}`;
    }

    if (enviromentUrl !== "") {
      url += url.includes("?")
        ? `&env=${enviromentUrl}`
        : `?env=${enviromentUrl}`;
    }
    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "PRODUCT_BLACKOUT_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "PRODUCT_BLACKOUT_RESPONSE_GET", value: error });
  }
}

export function* getSagaBlackoutList() {
  yield takeEvery("GET_LIST_BLACKOUT", getBlackoutList);
}

export function* getSagaProductBlackoutList() {
  yield takeEvery("GET_LIST_PRODUCT_BLACKOUT", getProductBlackoutList);
}

export function* getSagaBlackout() {
  yield takeEvery("GET_BLACKOUT", getBlackout);
}

export function* resetSagaBlackout() {
  yield takeEvery("RESET_BLACKOUT", resetBlackout);
}

export function* addSagaBlackout() {
  yield takeEvery("ADD_BLACKOUT", addBlackout);
}

export function* updateSagaBlackout() {
  yield takeEvery("UPDATE_BLACKOUT", updateBlackout);
}

export function* deleteSagaBlackout() {
  yield takeEvery("DELETE_BLACKOUT", deleteBlackout);
}

export function* addSagaBlackoutProduct() {
  yield takeEvery("ADD_BLACKOUT_PRODUCT", addBlackoutProduct);
}

export function* deleteSagaBlackoutProducts() {
  yield takeEvery("DELETE_BLACKOUT_PRODUCTS", deleteBlackoutProducts);
}

export function* getSagaBlackoutProducts() {
  yield takeEvery("GET_BLACKOUT_PRODUCTS", getBlackoutProducts);
}

export function* getSagaProductBlackout() {
  yield takeEvery("GET_PRODUCT_BLACKOUT", getProductBlackout);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
